import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CANCEL_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, bookingFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getWeekBookingSagaAction } from "../sagaActions";
import { BOOKING_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/cancel_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCancelBooking(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const bookingForm = yield select(state => state.bookingForm);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('booking_id', args.data.booking_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список записей
            yield put(getWeekBookingSagaAction({
                establishment: currentEstablishment,
                date: bookingForm.date
            }));

            // Очищаем форму записи
            yield put(bookingFormAction(BOOKING_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCancelBooking() {
    yield takeLatest(CANCEL_BOOKING_SAGA, workerCancelBooking);
}